import React from "react"
// import Button from "./basic-components/button"
import { Link, useStaticQuery, graphql } from "gatsby"

//import CardImage1 from "../assets/img/e-09w.jpg"
//import CardImage2 from "../assets/img/e-04w.jpg"
import { removeSlashFromSlug } from '../utils/additionalFunctions';
import CustomMarkdown from "../utils/customMarkdown"




import loadable from '@loadable/component'
const Button = loadable(() => import('./basic-components/button'))
const CarouselCard = loadable(() => import("./carousel-card"))

// import CardImage2 from "../assets/img/pexels-karolina-grabowska-5978712.jpg"

const Carousel = ({ component, title, Subtitle, data, url, optional, itemsPerRowS = 3, itemsPerRowM = 5, ctaUrl, ctaLabel, titleLabel, enforceH1 }) => {


    const handleGtag = (title) => {
        if (typeof window !== 'undefined' && typeof window.gtag !== 'undefined') {

            window.gtag('event', 'view_item', { 'event_category': 'ecommerce', 'event_label': `${title}` });

        }
    }

    const prodImages = useStaticQuery(graphql`
    {
        allJrmProductImages {
            edges {
              node {
                Path
                SDItemId
              }
            }
          }
    }
    `)

    if (data !== undefined) {

        return (
            <section className="carousel-section">   
                <div className="dark-section">
                    <div className="padding-top padding-bottom">
                        <div className="carousel-section-wrapper">
                            {enforceH1 && enforceH1 == 1 
                                    ? <h1 className="carousel-title">{title}</h1> 
                                    : <h2 className="carousel-title">{title}</h2>}

                            {enforceH1 && enforceH1 == 1 
                                    ? <hr/> 
                                    : ""}

                            <div className="lateral-padding ">
                                {Subtitle ?  <h3 className="">{Subtitle}</h3>:""}
                                {optional ? <CustomMarkdown className="carousel-description" children={optional} /> : ""}

                                {ctaLabel && ctaUrl ? (<div className="cta_url_carousel">
                                    <span>
                                        <Link to={ctaUrl}>{ctaLabel}</Link>
                                    </span>
                                </div>) : ''}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="white-section">
                    <div className="lateral-padding padding-top padding-bottom">
                        <div className="carousel-section-wrapper">
                            
                            <div className={"uk-child-width-1-" + itemsPerRowS + "@s uk-child-width-1-" + itemsPerRowM + "@m uk-text-center carousel-container"} data-uk-grid>
                                {data.map((item, i) => {

                                    var prodImgPath = null
                                    var firstImageFlag = false
                                    prodImages.allJrmProductImages.edges.forEach((imgItem, index) => {
                                        //if(index==0 && item.Name=='') { console.log(imgItem + ' index: ' + item.Id)}

                                        if (imgItem.node.SDItemId === item.Id && firstImageFlag == false) {
                                            prodImgPath = imgItem.node.Path
                                            firstImageFlag = true
                                        }


                                    })


                                    return (

                                        <div key={i} onClick={() => handleGtag(item.Name)}>

                                            <CarouselCard
                                                // img={(i%2===1)?CardImage1:CardImage2}
                                                img={prodImgPath ? process.env.GATSBY_IMAGE_PATH_URL + "/" + prodImgPath : process.env.GATSBY_DEFAULT_NA_IMAGE}
                                                title={item.Name}
                                                description={""}
                                                component={component}
                                                price={Math.round(item.AttractivePrice * 100) / 100}
                                                linkLabel={"View Product"}
                                                linkUrl={"/products/" + removeSlashFromSlug(item.Slug)}
                                                hidePrice={item.HidePrices}
                                            >
                                            </CarouselCard>
                                        </div>

                                    )
                                })}

                            </div>


                            {url ?

                                <div className="carousel-action">
                                    <Link to={url}>
                                        <Button label={titleLabel ? titleLabel : "See all collections"} use=""></Button>

                                    </Link>
                                </div> : ""
                            }
                        </div>

                    </div>
                </div>
            </section>
        )

    } else {
        return (<>Error passing data to component. Check if any data is sent to this component.</>)
    }

}

export default Carousel